import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataMenusReducer } from "../reducers";
import { InitialStateMenus } from "./models";

const initialState: InitialStateMenus = {
  items: [],
  allItemsView: [],
  allItemsMenu: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
};

const menusSlice = createSlice({
  name: "acessosApp/menus",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getMenus.fulfilled, dataMenusReducer);
  },
});

export const { openDialogForm, closeDialogForm } = menusSlice.actions;

export default menusSlice.reducer;
